import { SessionErrorCode } from './types';

const FALLBACK_SESSION_ERROR_MESSAGE_ID = 'sessionError.genericError';

const sessionErrorMessageIds: Record<SessionErrorCode, string> = {
  [SessionErrorCode.DELETED_SESSION]: 'classCard.thisSessionWasCanceled',
  [SessionErrorCode.SESSION_FULL]: 'classCard.thisClassIsFull',
};

export const getSessionErrorMessageId = (code: SessionErrorCode): string =>
  sessionErrorMessageIds[code] ?? FALLBACK_SESSION_ERROR_MESSAGE_ID;

export const getSessionErrorCode = (error: unknown): SessionErrorCode | undefined => {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return undefined;
  }

  const { response } = error;
  if (!response || typeof response !== 'object' || !('code' in response)) {
    return undefined;
  }

  const { code } = response;
  return Object.values(SessionErrorCode).includes(code as SessionErrorCode)
    ? (code as SessionErrorCode)
    : undefined;
};
